/**
 * TanStack keeps the prior query-key's data while a new period loads. That is
 * useful for layout stability, but it must never be rendered under the NEW
 * period label. Hide placeholder data until the matching request settles.
 */
export function currentPeriodData<T>(data: T | undefined, isPlaceholderData: boolean): T | undefined {
  return isPlaceholderData ? undefined : data;
}
